import { JubiliComponent } from "./jubili.component";
import { NgModule } from "@angular/core";
import { Http, HttpModule } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";

// Import Auth
// import { AuthGuardJubili } from "../security/authentication/guard/auth.guard.jubili";

// Import Module
import { JubiliRoutingModule } from "./jubili-routing.module";
import { SharedModule } from "../shared/shared.module";
import { CompanyManageModule } from "./company/company-manage.module";
// import { SettingModule } from "./setting/setting.module";

// Import Component
import { DashboardComponent } from "./dashboard/dashboard.component";
import { CompanyManageComponent } from "./company/company-manage.component";
// import { SettingComponent } from "./setting/setting.component";
import { InterceptorService } from "../../service/components/authentication/interceptor.service";
import { UserManageModule } from "./usermanage/user-manage.module";
import { UserManageComponent } from "./usermanage/user-manage.component";
import { QuotationItemModule } from "./quotation/quotation-item.module";
import { QuotationItemComponent } from "./quotation/quotation-item.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { SettingComponent } from "./setting/setting.component";
import { SettingModule } from "./setting/setting.module";
import { AuthGuardJubili } from "../../service/components/authentication/guards/auth.guard.jubili";
import { AuthGuard } from "../../service/components/authentication/guards/auth.guard";
import { AuthGuardJubiliService } from "../../service/api/jubili/auth-jubili.service";
import {UploadImageImportItemModule} from "./upload-image-imaport-item/upload-image-import-item.module";
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    BrowserModule,
    NgbModule.forRoot(),
    BsDatepickerModule.forRoot(),
    JubiliRoutingModule,
    SharedModule,
    CompanyManageModule,
    SettingModule,
    UploadImageImportItemModule,
    UserManageModule,
    QuotationItemModule,
    NgSelectModule
  ],
    declarations: [
        JubiliComponent,
        DashboardComponent,
        CompanyManageComponent,
        SettingComponent,
        UserManageComponent,
        QuotationItemComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        AuthGuard,
        AuthGuardJubili,
        AuthGuardJubiliService
    ]
})

export class JubiliModule { }
